'use client';
import { ChevronDownSVG, ChevronUpSVG } from '@snack-uikit/icons';
import { Droplist, ItemProps } from '@snack-uikit/list';
import { Typography } from '@snack-uikit/typography';
import cn from 'classnames';
import { useMemo, useState } from 'react';

import { Condition } from '@/components/static';
import { Fn } from '@/types/common';
import { reorderPlatforms } from '@/utils/platform';

import ns from './new-styles.module.scss';
import { SelectedContent } from './SelectedContent';
import s from './styles.module.scss';
import { makePlatformMultiselectOptions } from './utils';

type PlatformMultiSelectProps = {
  selectedOptions: string[];
  onSelect: Fn<string, unknown>;
  outerTriggerClassName?: string;
  metaPlatforms: string[];
  isLoadingOptions: boolean;
  lastVisibleSelectedItemIndex?: number;
};

export function PlatformMultiSelect({
  selectedOptions,
  onSelect,
  outerTriggerClassName,
  metaPlatforms,
  isLoadingOptions,
  lastVisibleSelectedItemIndex = 1,
}: PlatformMultiSelectProps) {
  const [opened, setOpened] = useState(false);
  const Chevron = opened ? ChevronUpSVG : ChevronDownSVG;

  const options: ItemProps[] = useMemo(
    () =>
      makePlatformMultiselectOptions(metaPlatforms.sort(reorderPlatforms)).map(({ name, Icon }) => ({
        beforeContent: Icon ? <Icon fill='#389F74' /> : null,
        checked: selectedOptions.includes(name),
        onClick() {
          setOpened(false);
          onSelect(name);
        },
        content: {
          option: name,
        },
      })),
    [metaPlatforms, onSelect, selectedOptions],
  );

  return (
    <Droplist
      loading={isLoadingOptions}
      items={options}
      open={opened}
      size='l'
      triggerClassName={outerTriggerClassName}
      selection={{ mode: 'multiple' }}
      onOpenChange={() => setOpened(prev => !prev)}
    >
      <div className={cn(ns.root, { [s.rootFocus]: opened })} role='button'>
        <div className={s.all_selected_options_wrapper}>
          <Condition when={selectedOptions.length > 1}>
            <Typography.SansBodyS className={s.option_label}>Облачная платформа</Typography.SansBodyS>
          </Condition>

          <SelectedContent
            lastVisibleSelectedItemIndex={lastVisibleSelectedItemIndex}
            metaPlatforms={metaPlatforms}
            selectedOptions={selectedOptions.sort(reorderPlatforms)}
          />
        </div>
        <Chevron />
      </div>
    </Droplist>
  );
}
